<template>
  <v-flex :class="classes">
    <v-menu
      ref="menu"
      v-model="menu"
      :close-on-content-click="false"
      :nudge-right="40"
      lazy
      transition="scale-transition"
      offset-y
      full-width
      min-width="290px"
    >
    
      <template v-slot:activator="{ on }">
        <v-text-field
          :value="nValue != undefined ? formatDate(nValue) : undefined"
          :label="label"
          :color="color"
          :placeholder="placeholder"
          :outline="outline"
          :box="box"
          :required="required"
          :rules="rules"
          :readonly="readonly && $route.params.id != 'new'"
          :disabled="disabled && $route.params.id != 'new'"
          v-on="on"
        ></v-text-field>
      </template>
      
      <v-date-picker
        header-color="third"
        color="navbartext"
        :value="date"
        @change="save"
      ></v-date-picker>
    </v-menu>
  </v-flex>
</template>

<script>
import { propsMixin } from '@/mixins/FieldsProps'
import moment from 'moment'

export default {
  mixins: [propsMixin],
  data() {
    return {
      date: '',
      menu: false
    }
  },
  created() {
    if (this.value) this.nValue = this.value
  },
  // watch: {
  //   menu (val) {
  //     val && setTimeout(() => (this.$refs.picker.activePicker = 'YEAR'))
  //   }
  // },
  methods: {
    save (date) {
      this.$refs.menu.save(date)
      
      this.date = date
      this.$emit('input', moment(date).unix() )
    },
		formatDate(date) {
      if (date.seconds) {
        return moment.unix(date.seconds).format('DD/MM/YYYY')
      } else if(date) {
        return moment(date).format('DD/MM/YYYY')
      }
		}
  }
}
</script>
